import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MesTableSelect from '@/components/MesTableSelect';
import MultilineInput from '@/components/MultilineInput';
import { GetSelectList } from '@/api/ListParam';
import util from '@/libs/util';
var props = {
  // 渲染类型 seq,radio,checkbox,expand,html
  type: String,
  // 列字段名
  field: String,
  // 列标题
  title: String,
  // 列宽度
  width: [Number, String],
  // 列最小宽度，把剩余宽度按比例分配
  minWidth: [Number, String],
  // 是否允许拖动列宽调整大小
  resizable: {
    type: Boolean,
    default: null
  },
  // 将列固定在左侧或者右侧
  fixed: String,
  // 列对其方式
  align: String,
  // 表头对齐方式
  headerAlign: String,
  // 表尾列的对齐方式
  footerAlign: String,
  // 当内容过长时显示为省略号
  showOverflow: {
    type: [Boolean, String],
    default: null
  },
  // 当表头内容过长时显示为省略号
  showHeaderOverflow: {
    type: [Boolean, String],
    default: null
  },
  // 当表尾内容过长时显示为省略号
  showFooterOverflow: {
    type: [Boolean, String],
    default: null
  },
  // 给单元格附加 className
  className: [String, Function],
  // 给表头单元格附加 className
  headerClassName: [String, Function],
  // 给表尾单元格附加 className
  footerClassName: [String, Function],
  // 格式化显示内容
  formatter: [Function, Array, String],
  // 是否允许排序
  sortable: Boolean,
  // 在 v3 中废弃
  remoteSort: {
    type: Boolean,
    default: null
  },
  // 在 v3 中只支持字符串类型
  sortBy: [String, Function],
  // 排序的字段类型，比如字符串转数值等
  sortType: String,
  // 在 v3 中废弃
  sortMethod: Function,
  // 配置筛选条件数组
  filters: {
    type: Array,
    default: null
  },
  // 筛选是否允许多选
  filterMultiple: {
    type: Boolean,
    default: true
  },
  // 自定义筛选方法
  filterMethod: Function,
  // 筛选重置方法
  filterResetMethod: Function,
  // 筛选复原方法
  filterRecoverMethod: Function,
  // 筛选模板配置项
  filterRender: Object,
  // 指定为树节点
  treeNode: Boolean,
  // 是否可视
  visible: {
    type: Boolean,
    default: null
  },
  // 父组件是否使用插槽
  useSolt: {
    type: Boolean,
    default: false
  },
  // 父组件是否使用查询输入框
  useSearch: {
    type: Boolean,
    default: true
  },
  // 配置查询条件数组
  columnsWhere: {
    type: Object,
    default: null
  },
  // 单元格数据导出方法
  exportMethod: Function,
  // 表尾单元格数据导出方法
  footerExportMethod: Function,
  // 标题帮助图标配置项
  titleHelp: Object,
  // 单元格值类型
  cellType: String,
  // 单元格渲染配置项
  cellRender: Object,
  // 单元格编辑渲染配置项
  editRender: Object,
  // 内容渲染配置项
  contentRender: Object,
  // 额外的参数
  params: Object
};
export default {
  name: 'MesColumn',
  props: props,
  data: function data() {
    return {
      isEnterKeyUp: false,
      optionData: [],
      mesTableRef: null
    };
  },
  components: {
    MesTableSelect: MesTableSelect,
    MultilineInput: MultilineInput
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.mesTableRef = _this.$parent.$parent;
    });
  },
  watch: {
    // 设置默认值为当前查询条件
    'columnsWhere.DEFAULT_VALUE': {
      handler: function handler(val) {
        if (val) {
          // this.ParamList[this.field] = val
          this.$set(this.ParamList, this.field, val);
          this.setMesTableParamListByColumnsWhere(this.columnsWhere);
          /**
           * 加载选项，否则界面会显示数值
           */

          switch (this.columnsWhere.DATA_TYPE) {
            // 下拉框
            case 2:
              if (this.columnsWhere.IS_PAGING !== 'Y') {
                this.handleParamListData(true, this.columnsWhere);
              }

              break;
            // 多选下拉框
          }
        }
      }
    }
  },
  inject: ['ParamList', 'isColumn'],
  methods: {
    /**
     * @description 设置MesTable组件的ParamListNew属性
     */
    setMesTableParamListByColumnsWhere: function setMesTableParamListByColumnsWhere(columnsWhere) {
      var key = columnsWhere['PARAM_NAME'];
      var param = {
        PARAM_NAME: key,
        ACTION_TYPE: columnsWhere['ACTION_TYPE'],
        PARAM_VALUE: this.ParamList[key],
        DATA_TYPE: columnsWhere['DATA_TYPE'] // AGGREGATION: columnsWhere['AGGREGATION']

      }; // 时间段
      // if ([5].includes(parseInt(columnsWhere['DATA_TYPE'])) && Array.isArray(this.ParamList[key])) {
      //   param.PARAM_VALUE = this.ParamList[key].join('-')
      // }

      this.mesTableRef.setParamListNewByParam(param);
    },
    handleClear: function handleClear(columnsWhere) {
      this.handelEnterKeyUp(columnsWhere);
    },
    MesTableData: function MesTableData(val, columnsWhere) {
      this.ParamList[columnsWhere.PARAM_NAME] = val.CODE.toString();
      this.handelEnterKeyUp(columnsWhere);
    },
    // 时间选择
    handleParamListTime: function handleParamListTime(val, columnsWhere) {
      this.handelEnterKeyUp(columnsWhere);
    },
    // 时间段选择
    handleParamListTimeRange: function handleParamListTimeRange(val, columnsWhere) {
      this.handelEnterKeyUp(columnsWhere);
    },
    // 下拉框选择
    handleParamListSelect: function handleParamListSelect(val, columnsWhere) {
      this.handelEnterKeyUp(columnsWhere);
    },
    // 数字计数框
    handleParamListNumber: function handleParamListNumber(val, columnsWhere) {
      this.handelEnterKeyUp(columnsWhere);
    },
    // 下拉数据
    handleParamListData: function handleParamListData(flag, row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!flag) {
                  _context.next = 9;
                  break;
                }

                if (!row.DATA_REPORT) {
                  _context.next = 5;
                  break;
                }

                _this2.optionData = row.DATA_REPORT;
                _context.next = 9;
                break;

              case 5:
                _context.next = 7;
                return GetSelectList({
                  PARAM_NAME: row.PARAM_NAME
                });

              case 7:
                res = _context.sent;

                // console.log('下拉',res);
                if (res.data) {
                  _this2.optionData = res.data;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setMestTableParamListByColumnsWhere: function setMestTableParamListByColumnsWhere(columnsWhere) {
      var key = columnsWhere.PARAM_NAME;
      var param = {
        PARAM_NAME: key,
        ACTION_TYPE: columnsWhere.ACTION_TYPE,
        PARAM_VALUE: this.ParamList[key],
        DATA_TYPE: columnsWhere.DATA_TYPE // AGGREGATION: columnsWhere['AGGREGATION']

      }; // 时间段

      if ([5].includes(parseInt(columnsWhere.DATA_TYPE)) && Array.isArray(this.ParamList[key])) {
        param.PARAM_VALUE = this.ParamList[key].join('-');
      }

      this.mesTableRef.setParamListNewByParam(param);
    },
    // 列表回车
    handelEnterKeyUp: function handelEnterKeyUp(columnsWhere) {
      this.setMesTableParamListByColumnsWhere(columnsWhere); // 过滤空数据，空数组

      var params = this.mesTableRef.ParamListNew.filter(function (e) {
        return !util.isEmptyWithAllType(e.PARAM_VALUE);
      });
      this.mesTableRef.handleParamList(params); // console.log('选择')
      // if (JSON.stringify(this.ParamList) !== '{}') {
      //   const ParamList = []
      //   Object.keys(this.ParamList).map((keys) => {
      //     // 处理时间段
      //     let dateTimePick = null
      //     if (this.ParamList[keys] && parseInt(columnsWhere.DATA_TYPE) === 5) {
      //       dateTimePick = this.ParamList[keys][0] + '-' + this.ParamList[keys][1]
      //     }
      //     ParamList.push({
      //       PARAM_NAME: keys,
      //       ACTION_TYPE: columnsWhere.ACTION_TYPE,
      //       PARAM_VALUE: dateTimePick != null ? dateTimePick : this.ParamList[keys],
      //       DATA_TYPE: columnsWhere.DATA_TYPE
      //     })
      //   })
      //   this.$parent.$parent.handleParamList(ParamList)
      // }
    },
    // 点击高级配置按钮
    handleDrawerVisible: function handleDrawerVisible() {
      var _this3 = this;

      this.seniorDrawer = true;
      this.$nextTick(function (_) {
        _this3.$refs.SeniorSetting.handleSearchTableLoad();
      });
    },
    // 点击高级查询按钮
    handleDialogVisible: function handleDialogVisible() {
      var _this4 = this;

      this.dialogVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.SeniorSearch.handleSearchTableLoad();
      });
    },
    // 高级查询状态开关
    handleColseSearch: function handleColseSearch(flag) {
      this.dialogVisible = flag;
    },
    // 高级查询
    handelSeniorSearch: function handelSeniorSearch() {
      this.dialogVisible = true;
    },
    // 高级配置状态开关
    handleColseSetting: function handleColseSetting(flag) {
      this.seniorDrawer = flag;
    }
  }
};